import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

// Styling
import styles from './styles';

class DescriptionText extends Component {
  render(){
    const { classes } = this.props;
    return(
      <Typography className={classes.root} type="sub-heading" color="white" gutterBottom align="center">
        Welcome to DSN. Press on the Get Started button below.
      </Typography>
    );
  }
}

DescriptionText.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(DescriptionText);



// WEBPACK FOOTER //
// ./src/scenes/GetStarted/components/DescriptionText/index.js